import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';
import smoothScrollIntoView from 'smooth-scroll-into-view-if-needed';

let scrollIntoView;
if (typeof document !== "undefined") {
  scrollIntoView = "scrollBehavior" in document.documentElement.style ? scrollIntoViewIfNeeded : smoothScrollIntoView;
}

export { scrollIntoView };
//# sourceMappingURL=scrollIntoView.es.js.map
